var map = {
	".": [
		64739,
		9
	],
	"./": [
		64739,
		9
	],
	"./App": [
		81622,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.js": [
		81622,
		9
	],
	"./App.test": [
		55653,
		9,
		2012,
		6004,
		6598
	],
	"./App.test.js": [
		55653,
		9,
		2012,
		6004,
		6598
	],
	"./DomainConstants": [
		4933,
		9
	],
	"./DomainConstants.js": [
		4933,
		9
	],
	"./DomainFunctions": [
		43841,
		9,
		3841
	],
	"./DomainFunctions.js": [
		43841,
		9,
		3841
	],
	"./Styles": [
		60971,
		9
	],
	"./Styles.js": [
		60971,
		9
	],
	"./assets/Admin/LOGINIMAGE.png": [
		30574,
		1,
		574
	],
	"./assets/Authentication/GroceryStoreCard.png": [
		98831,
		1,
		8831
	],
	"./assets/Authentication/RestauarantStoreCard.png": [
		82032,
		1,
		9651
	],
	"./assets/Authentication/RetailStoreCard.png": [
		32003,
		1,
		2003
	],
	"./assets/CloseIcon": [
		65531,
		9,
		5531
	],
	"./assets/CloseIcon.jsx": [
		65531,
		9,
		5531
	],
	"./assets/CopyIcon": [
		40158,
		9,
		7739,
		158
	],
	"./assets/CopyIcon.jsx": [
		40158,
		9,
		7739,
		158
	],
	"./assets/CustomerProfile/Nonveg.svg": [
		90793,
		1,
		793
	],
	"./assets/CustomerProfile/OrdersComponent": [
		98542,
		9,
		8542
	],
	"./assets/CustomerProfile/OrdersComponent.jsx": [
		98542,
		9,
		8542
	],
	"./assets/CustomerProfile/Vector.svg": [
		29581,
		1,
		9581
	],
	"./assets/CustomerProfile/delete.svg": [
		25577,
		1,
		5577
	],
	"./assets/CustomerProfile/delivery.svg": [
		67288,
		1,
		7288
	],
	"./assets/CustomerProfile/delivery1.svg": [
		7241,
		1,
		7241
	],
	"./assets/CustomerProfile/dinein.svg": [
		43335,
		1,
		3335
	],
	"./assets/CustomerProfile/dinein1.svg": [
		91092,
		1,
		1092
	],
	"./assets/CustomerProfile/edit.svg": [
		77332,
		1,
		7332
	],
	"./assets/CustomerProfile/feastoIcon.png": [
		79681,
		1,
		9681
	],
	"./assets/CustomerProfile/navigate.svg": [
		71345,
		1,
		6107
	],
	"./assets/CustomerProfile/pickup.svg": [
		42540,
		1,
		2540
	],
	"./assets/CustomerProfile/store.svg": [
		9643,
		1,
		9643
	],
	"./assets/CustomerProfile/store1.svg": [
		11168,
		1,
		1168
	],
	"./assets/EmptyPage/customerNotSignin.svg": [
		22684,
		1,
		2684
	],
	"./assets/EmptyPage/emptyCustomerCart.svg": [
		99576,
		1,
		9576
	],
	"./assets/EmptyPage/emptyMenu.svg": [
		50581,
		1,
		5343
	],
	"./assets/EmptyPage/emptyOffers.svg": [
		77839,
		1,
		7839
	],
	"./assets/EmptyPage/emptyPaymentMethods.svg": [
		10506,
		1,
		506
	],
	"./assets/EmptyPage/emptyVendorMenu.svg": [
		21117,
		1,
		1117
	],
	"./assets/EmptyPage/noActiveOrders.svg": [
		39907,
		1,
		9907
	],
	"./assets/EmptyPage/noCompletedOrders.svg": [
		43678,
		1,
		3678
	],
	"./assets/ExportPdf/preparing.gif": [
		43316,
		1,
		935
	],
	"./assets/FailureIcon": [
		30981,
		9,
		981
	],
	"./assets/FailureIcon.jsx": [
		30981,
		9,
		981
	],
	"./assets/Icons": [
		78130,
		9,
		8130
	],
	"./assets/Icons.jsx": [
		78130,
		9,
		8130
	],
	"./assets/Landing Page/AnalyticsImg.webp": [
		27718,
		1,
		7718
	],
	"./assets/Landing Page/AnnuallyArrowIcon.webp": [
		16807,
		1,
		6807
	],
	"./assets/Landing Page/ArrowGrowthIcon.png": [
		49773,
		1,
		2154
	],
	"./assets/Landing Page/CareersPageImgs/random1.webp": [
		97754,
		1,
		7754
	],
	"./assets/Landing Page/CareersPageImgs/random2.webp": [
		84603,
		1,
		4603
	],
	"./assets/Landing Page/CareersPageImgs/random3.webp": [
		8152,
		1,
		8152
	],
	"./assets/Landing Page/CareersPageImgs/random4.webp": [
		16721,
		1,
		6721
	],
	"./assets/Landing Page/CareersPageImgs/random5.webp": [
		59446,
		1,
		9446
	],
	"./assets/Landing Page/CareersPageImgs/random6.webp": [
		96823,
		1,
		6823
	],
	"./assets/Landing Page/CompaniesBrandLogos/BANANA_CHILL.png": [
		16943,
		1,
		9324
	],
	"./assets/Landing Page/CompaniesBrandLogos/FOOD_CORNER.png": [
		16522,
		1,
		6522
	],
	"./assets/Landing Page/CompaniesBrandLogos/INDUS_CUISINE.png": [
		91206,
		1,
		1206
	],
	"./assets/Landing Page/CompaniesBrandLogos/JAVA_FOODS.png": [
		68134,
		1,
		8134
	],
	"./assets/Landing Page/CompaniesBrandLogos/JC.png": [
		32205,
		1,
		2205
	],
	"./assets/Landing Page/CompaniesBrandLogos/LULLABY.png": [
		10963,
		1,
		963
	],
	"./assets/Landing Page/CompaniesBrandLogos/MC.png": [
		34832,
		1,
		4832
	],
	"./assets/Landing Page/CompaniesBrandLogos/NARAMPANAWA.png": [
		38413,
		1,
		8413
	],
	"./assets/Landing Page/CompaniesBrandLogos/QUEEN_CHEF.png": [
		47129,
		1,
		7129
	],
	"./assets/Landing Page/CompaniesBrandLogos/RED.png": [
		1167,
		1,
		1167
	],
	"./assets/Landing Page/CompaniesBrandLogos/SOUTH_INDIAN_CUISINE.png": [
		77384,
		1,
		7384
	],
	"./assets/Landing Page/CompaniesBrandLogos/Thamili.png": [
		52632,
		1,
		2632
	],
	"./assets/Landing Page/DiscoverWhatFeastoImg.webp": [
		2887,
		1,
		2887
	],
	"./assets/Landing Page/DiscoverWhatFeastoImg_1.webp": [
		73035,
		1,
		3035
	],
	"./assets/Landing Page/DiscoverWhatFeastoImg_2.webp": [
		71146,
		1,
		1146
	],
	"./assets/Landing Page/DiscoverWhatFeastoImg_3.webp": [
		75413,
		1,
		5413
	],
	"./assets/Landing Page/DiscoverWhatFeastoImg_4.webp": [
		73732,
		1,
		3732
	],
	"./assets/Landing Page/ExploreFeasto.webp": [
		61816,
		1,
		1816
	],
	"./assets/Landing Page/FasterReplyIcon.png": [
		17225,
		1,
		7225
	],
	"./assets/Landing Page/GroceryMockup1.png": [
		14762,
		1,
		4762
	],
	"./assets/Landing Page/Instagram.webp": [
		73339,
		1,
		5720
	],
	"./assets/Landing Page/LinkedIn.webp": [
		75431,
		1,
		5431
	],
	"./assets/Landing Page/LogoFeasto.webp": [
		88310,
		1,
		8310
	],
	"./assets/Landing Page/Mockup1.webp": [
		92641,
		1,
		2641
	],
	"./assets/Landing Page/Mockup2.webp": [
		88356,
		1,
		8356
	],
	"./assets/Landing Page/Mockup2Grocery.png": [
		32789,
		1,
		2789
	],
	"./assets/Landing Page/Mockup2Retail.png": [
		57987,
		1,
		7987
	],
	"./assets/Landing Page/Mockup3.webp": [
		42055,
		1,
		2055
	],
	"./assets/Landing Page/Mockup3Grocery.png": [
		12626,
		1,
		2626
	],
	"./assets/Landing Page/Mockup3Retail.png": [
		97578,
		1,
		7578
	],
	"./assets/Landing Page/Mockup4.webp": [
		42570,
		1,
		2570
	],
	"./assets/Landing Page/Mockup5.webp": [
		88085,
		1,
		8085
	],
	"./assets/Landing Page/OruStoryImg1.webp": [
		17086,
		1,
		7086
	],
	"./assets/Landing Page/OruStoryImg2.webp": [
		14239,
		1,
		4239
	],
	"./assets/Landing Page/OruStoryImg3.webp": [
		12700,
		1,
		2700
	],
	"./assets/Landing Page/OurTeamSecBackground.webp": [
		19569,
		1,
		9569
	],
	"./assets/Landing Page/OurValuesIcons/creatingMagic.webp": [
		79790,
		1,
		9790
	],
	"./assets/Landing Page/OurValuesIcons/empathy.webp": [
		97588,
		1,
		7588
	],
	"./assets/Landing Page/OurValuesIcons/excellence.webp": [
		6054,
		1,
		6054
	],
	"./assets/Landing Page/OurValuesIcons/integrity.webp": [
		48759,
		1,
		8759
	],
	"./assets/Landing Page/OurValuesIcons/velocity.webp": [
		38411,
		1,
		8411
	],
	"./assets/Landing Page/PhoneDedicatedWebStore.webp": [
		29859,
		1,
		9859
	],
	"./assets/Landing Page/PhoneFeasto.webp": [
		35235,
		1,
		5235
	],
	"./assets/Landing Page/PhoneFullFlexibility.webp": [
		40013,
		1,
		13
	],
	"./assets/Landing Page/PhonePainlessOrder.webp": [
		40402,
		1,
		402
	],
	"./assets/Landing Page/RestaurantMockup1.png": [
		41858,
		1,
		1858
	],
	"./assets/Landing Page/RestaurantMockup2.png": [
		97945,
		1,
		7945
	],
	"./assets/Landing Page/RestaurantMockup3.png": [
		91696,
		1,
		1696
	],
	"./assets/Landing Page/RestaurantMockup4.png": [
		87567,
		1,
		7567
	],
	"./assets/Landing Page/RestaurantMockup5.png": [
		64902,
		1,
		4902
	],
	"./assets/Landing Page/RestaurantMockup6.png": [
		46109,
		1,
		6109
	],
	"./assets/Landing Page/RetailMockup1.png": [
		68578,
		1,
		8578
	],
	"./assets/Landing Page/RocketLaunch.webp": [
		67402,
		1,
		7402
	],
	"./assets/Landing Page/RocketLaunchIcon.png": [
		68841,
		1,
		8841
	],
	"./assets/Landing Page/ScheduleTime.png": [
		87643,
		1,
		7643
	],
	"./assets/Landing Page/StoreTempleteGrocery.webp": [
		11403,
		1,
		1403
	],
	"./assets/Landing Page/StoreTempleteRestaurant.webp": [
		51555,
		1,
		1555
	],
	"./assets/Landing Page/StoreTempleteRetail.webp": [
		60307,
		1,
		307
	],
	"./assets/Landing Page/Stroke.svg": [
		88187,
		1,
		8187
	],
	"./assets/Landing Page/TeamMembers/Ilma.webp": [
		39307,
		1,
		9307
	],
	"./assets/Landing Page/TeamMembers/Naresh.webp": [
		91087,
		1,
		1087
	],
	"./assets/Landing Page/TeamMembers/Sasitharan.webp": [
		60140,
		1,
		140
	],
	"./assets/Landing Page/TeamMembers/Sheron.webp": [
		65781,
		1,
		5781
	],
	"./assets/Landing Page/TeamMembers/Sivashangari.webp": [
		98836,
		1,
		8836
	],
	"./assets/Landing Page/TeamMembers/Sooriyakumar.webp": [
		98852,
		1,
		8852
	],
	"./assets/Landing Page/TeamMembers/Thibishna.webp": [
		56428,
		1,
		6428
	],
	"./assets/Landing Page/TeamMembers/Vijay.webp": [
		79915,
		1,
		9915
	],
	"./assets/Landing Page/TestimonialLogo1.png": [
		71998,
		1,
		1998
	],
	"./assets/Landing Page/TestimonialLogo2.png": [
		57749,
		1,
		130
	],
	"./assets/Landing Page/TestimonialLogo3.png": [
		21836,
		1,
		1836
	],
	"./assets/Landing Page/UltimateControllerIcon.png": [
		80785,
		1,
		785
	],
	"./assets/Landing Page/WhatsApp.webp": [
		98295,
		1,
		8295
	],
	"./assets/Landing Page/WhatsApp2.webp": [
		66631,
		1,
		6631
	],
	"./assets/Landing Page/WhoWeAreImg.webp": [
		41250,
		1,
		1250
	],
	"./assets/Landing Page/facebook.webp": [
		13101,
		1,
		3101
	],
	"./assets/Landing Page/privacyOrTermsBackground.webp": [
		23369,
		1,
		3369
	],
	"./assets/Landing Page/stroke.webp": [
		5473,
		1,
		5473
	],
	"./assets/VendorOrders/OffersWebView.svg": [
		21612,
		1,
		1612
	],
	"./assets/VendorOrders/OrdersWebViewIcon.svg": [
		52769,
		1,
		2769
	],
	"./assets/VendorOrders/PosWebView.svg": [
		33261,
		1,
		3261
	],
	"./assets/VendorOrders/ServicesWebView.svg": [
		5955,
		1,
		5955
	],
	"./assets/VendorOrders/SettingsWebViewIcon.svg": [
		58637,
		1,
		8637
	],
	"./assets/VendorOrders/StoreWebViewIcon.svg": [
		41865,
		1,
		1865
	],
	"./assets/VendorOrders/vendorOrderCancelled.svg": [
		50721,
		1,
		721
	],
	"./assets/VendorOrders/vendorOrderCompletedForDelivery.svg": [
		43244,
		1,
		3244
	],
	"./assets/VendorOrders/vendorOrderCompletedForDinein.svg": [
		71459,
		1,
		1459
	],
	"./assets/VendorOrders/vendorOrderCompletedForTakeaway.svg": [
		86827,
		1,
		6827
	],
	"./assets/VendorProfile/ReorderComponent": [
		95108,
		9,
		5108
	],
	"./assets/VendorProfile/ReorderComponent.jsx": [
		95108,
		9,
		5108
	],
	"./assets/VendorProfile/akarIcon.svg": [
		90788,
		1,
		788
	],
	"./assets/VendorProfile/blackSquare.svg": [
		88510,
		1,
		8510
	],
	"./assets/VendorProfile/blackrevenue.svg": [
		93261,
		1,
		8023
	],
	"./assets/VendorProfile/defaultProfileImage.png": [
		65883,
		1,
		5883
	],
	"./assets/VendorProfile/domainsEmpty.svg": [
		27368,
		1,
		7368
	],
	"./assets/VendorProfile/facebook.svg": [
		99030,
		1,
		9030
	],
	"./assets/VendorProfile/google.png": [
		12417,
		1,
		2417
	],
	"./assets/VendorProfile/instagram.svg": [
		50962,
		1,
		962
	],
	"./assets/VendorProfile/reorder.svg": [
		24359,
		1,
		4359
	],
	"./assets/VendorProfile/revenuesummary.svg": [
		42958,
		1,
		2958
	],
	"./assets/VendorProfile/salesinsight.svg": [
		47794,
		1,
		7794
	],
	"./assets/VendorProfile/squaresummary.svg": [
		97105,
		1,
		7105
	],
	"./assets/VendorProfile/store.svg": [
		14101,
		1,
		4101
	],
	"./assets/VendorProfile/tiktok.png": [
		62178,
		1,
		2178
	],
	"./assets/VendorProfile/timezone.svg": [
		2103,
		1,
		2103
	],
	"./assets/VendorProfile/webLink.svg": [
		53616,
		1,
		3616
	],
	"./assets/VendorProfile/whatsapp.svg": [
		54100,
		1,
		4100
	],
	"./assets/VendorProfile/youtube.png": [
		52777,
		1,
		2777
	],
	"./assets/VendorSubscription/AmericanExpress.png": [
		87670,
		1,
		7670
	],
	"./assets/VendorSubscription/MasterCard.png": [
		11710,
		1,
		1710
	],
	"./assets/VendorSubscription/VisaCard.png": [
		88443,
		1,
		8443
	],
	"./assets/addNewDeliveryAddress.svg": [
		19809,
		1,
		9809
	],
	"./assets/feasto": [
		61110,
		9
	],
	"./assets/feasto.jsx": [
		61110,
		9
	],
	"./assets/noDigitalPaymentMethods.svg": [
		1929,
		1,
		1929
	],
	"./assets/payhere.png": [
		41058,
		1
	],
	"./assets/paypal.png": [
		32589,
		1
	],
	"./assets/stripe.png": [
		5611,
		1
	],
	"./assets/successTick": [
		84262,
		9,
		4262
	],
	"./assets/successTick.jsx": [
		84262,
		9,
		4262
	],
	"./assets/teaching.png": [
		8661,
		1,
		8661
	],
	"./components/Admin/Sections/ChangeContactNumberShopDetails": [
		87491,
		9,
		7195,
		681,
		7491,
		5316
	],
	"./components/Admin/Sections/ChangeContactNumberShopDetails.jsx": [
		87491,
		9,
		7195,
		681,
		7491,
		5316
	],
	"./components/Admin/Sections/DeleteAccountShopDetails": [
		16,
		9,
		16,
		5316
	],
	"./components/Admin/Sections/DeleteAccountShopDetails.jsx": [
		16,
		9,
		16,
		5316
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/Confirm": [
		2153,
		9,
		2153
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/Confirm.jsx": [
		2153,
		9,
		2153
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/FinalConfirm": [
		83841,
		9,
		6222
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/FinalConfirm.jsx": [
		83841,
		9,
		6222
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/Inform": [
		77950,
		9,
		7950
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/Inform.jsx": [
		77950,
		9,
		7950
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/NewContactNumber": [
		43260,
		9,
		7195,
		681,
		3260
	],
	"./components/Admin/Sections/DialogBoxes/ChangeContactNumberRequest/NewContactNumber.jsx": [
		43260,
		9,
		7195,
		681,
		3260
	],
	"./components/Admin/Sections/DialogBoxes/DeleteAccountRequest/Confirm": [
		59554,
		9,
		9554
	],
	"./components/Admin/Sections/DialogBoxes/DeleteAccountRequest/Confirm.jsx": [
		59554,
		9,
		9554
	],
	"./components/Admin/Sections/DialogBoxes/DeleteAccountRequest/FinalConfirm": [
		43648,
		9,
		3648
	],
	"./components/Admin/Sections/DialogBoxes/DeleteAccountRequest/FinalConfirm.jsx": [
		43648,
		9,
		3648
	],
	"./components/Admin/Sections/DialogBoxes/DeleteAccountRequest/Inform": [
		90491,
		9,
		491
	],
	"./components/Admin/Sections/DialogBoxes/DeleteAccountRequest/Inform.jsx": [
		90491,
		9,
		491
	],
	"./components/Admin/Sections/DialogBoxes/Vendors/Confimation": [
		99271,
		9,
		9271
	],
	"./components/Admin/Sections/DialogBoxes/Vendors/Confimation.jsx": [
		99271,
		9,
		9271
	],
	"./components/Admin/Sections/DialogBoxes/Vendors/Inform": [
		61809,
		9,
		1809
	],
	"./components/Admin/Sections/DialogBoxes/Vendors/Inform.jsx": [
		61809,
		9,
		1809
	],
	"./components/Admin/Sections/TopNavigationBar": [
		6274,
		9,
		3316,
		6274
	],
	"./components/Admin/Sections/TopNavigationBar.jsx": [
		6274,
		9,
		3316,
		6274
	],
	"./components/Admin/Sections/VendorShopDetails": [
		34290,
		9,
		4290,
		5316
	],
	"./components/Admin/Sections/VendorShopDetails.jsx": [
		34290,
		9,
		4290,
		5316
	],
	"./components/Admin/Utils/AdminStyledObjects": [
		8899,
		9,
		8899
	],
	"./components/Admin/Utils/AdminStyledObjects.js": [
		8899,
		9,
		8899
	],
	"./components/Admin/Utils/FieldFormatter": [
		14561,
		9,
		4561
	],
	"./components/Admin/Utils/FieldFormatter.js": [
		14561,
		9,
		4561
	],
	"./components/Admin/ViewVendorContactNumberChangeRequests": [
		58797,
		9,
		7739,
		7195,
		681,
		2871,
		3229,
		3316,
		3071,
		7491,
		8797
	],
	"./components/Admin/ViewVendorContactNumberChangeRequests.jsx": [
		58797,
		9,
		7739,
		7195,
		681,
		2871,
		3229,
		3316,
		3071,
		7491,
		8797
	],
	"./components/Admin/ViewVendorDeleteAccountRequests": [
		90232,
		9,
		7739,
		2871,
		3229,
		3316,
		3071,
		16,
		232
	],
	"./components/Admin/ViewVendorDeleteAccountRequests.jsx": [
		90232,
		9,
		7739,
		2871,
		3229,
		3316,
		3071,
		16,
		232
	],
	"./components/Admin/ViewVendorPaymentScreen": [
		27354,
		9,
		7739,
		2871,
		3229,
		3316,
		3071,
		7354
	],
	"./components/Admin/ViewVendorPaymentScreen.jsx": [
		27354,
		9,
		7739,
		2871,
		3229,
		3316,
		3071,
		7354
	],
	"./components/Admin/ViewVendors": [
		22927,
		9,
		7739,
		2871,
		3229,
		3316,
		3071,
		4290,
		2927
	],
	"./components/Admin/ViewVendors.jsx": [
		22927,
		9,
		7739,
		2871,
		3229,
		3316,
		3071,
		4290,
		2927
	],
	"./components/Admin/authentication/AdminSignIn": [
		32781,
		9,
		2781
	],
	"./components/Admin/authentication/AdminSignIn.jsx": [
		32781,
		9,
		2781
	],
	"./components/Customer/AddNewAddressDialog": [
		9445,
		9,
		7739,
		7195,
		681,
		4018,
		9445
	],
	"./components/Customer/AddNewAddressDialog.jsx": [
		9445,
		9,
		7739,
		7195,
		681,
		4018,
		9445
	],
	"./components/Customer/AddNewDeliveryAddress": [
		12082,
		9,
		7739,
		7195,
		681,
		4018,
		2082
	],
	"./components/Customer/AddNewDeliveryAddress.jsx": [
		12082,
		9,
		7739,
		7195,
		681,
		4018,
		2082
	],
	"./components/Customer/CustomerGridViewItemCard": [
		53052,
		9,
		3052
	],
	"./components/Customer/CustomerGridViewItemCard.jsx": [
		53052,
		9,
		3052
	],
	"./components/Customer/CustomerListViewItemCard": [
		95704,
		9,
		5704
	],
	"./components/Customer/CustomerListViewItemCard.jsx": [
		95704,
		9,
		5704
	],
	"./components/Customer/DeliveryAddress": [
		54862,
		9,
		7739,
		7195,
		681,
		8071,
		4018,
		4862
	],
	"./components/Customer/DeliveryAddress.jsx": [
		54862,
		9,
		7739,
		7195,
		681,
		8071,
		4018,
		4862
	],
	"./components/Customer/ItemInfo": [
		34485,
		9,
		8071,
		6726,
		4485,
		4709
	],
	"./components/Customer/ItemInfo.jsx": [
		34485,
		9,
		8071,
		6726,
		4485,
		4709
	],
	"./components/Customer/MediaLinkSection": [
		19269,
		9,
		4353,
		9334,
		9269
	],
	"./components/Customer/MediaLinkSection.jsx": [
		19269,
		9,
		4353,
		9334,
		9269
	],
	"./components/Customer/MyCart": [
		95952,
		9,
		7739,
		7195,
		681,
		4018,
		8776,
		5952,
		3639
	],
	"./components/Customer/MyCart.jsx": [
		95952,
		9,
		7739,
		7195,
		681,
		4018,
		8776,
		5952,
		3639
	],
	"./components/Customer/Offers/OfferCard": [
		27968,
		9,
		7968
	],
	"./components/Customer/Offers/OfferCard.jsx": [
		27968,
		9,
		7968
	],
	"./components/Customer/Offers/ViewOffersForVendor": [
		75513,
		9,
		2360,
		5513
	],
	"./components/Customer/Offers/ViewOffersForVendor.jsx": [
		75513,
		9,
		2360,
		5513
	],
	"./components/Customer/OrderConfirmation": [
		70973,
		9,
		2871,
		223,
		7326,
		973
	],
	"./components/Customer/OrderConfirmation.jsx": [
		70973,
		9,
		2871,
		223,
		7326,
		973
	],
	"./components/Customer/OrderSummary": [
		68440,
		9,
		7195,
		681,
		4018,
		6536,
		5255,
		4847,
		8440
	],
	"./components/Customer/OrderSummary.jsx": [
		68440,
		9,
		7195,
		681,
		4018,
		6536,
		5255,
		4847,
		8440
	],
	"./components/Customer/OrderingProcess/Section/DateSchedulerPopup": [
		49694,
		9,
		2871,
		223,
		7326,
		9694
	],
	"./components/Customer/OrderingProcess/Section/DateSchedulerPopup.jsx": [
		49694,
		9,
		2871,
		223,
		7326,
		9694
	],
	"./components/Customer/OrderingProcess/Section/DeleteAnItemConfirmationDialog": [
		66148,
		9,
		6148
	],
	"./components/Customer/OrderingProcess/Section/DeleteAnItemConfirmationDialog.jsx": [
		66148,
		9,
		6148
	],
	"./components/Customer/OrderingProcess/Section/TimeSchedulerPopup": [
		27326,
		9,
		223,
		7326
	],
	"./components/Customer/OrderingProcess/Section/TimeSchedulerPopup.jsx": [
		27326,
		9,
		223,
		7326
	],
	"./components/Customer/PaymentFailureMsg": [
		51165,
		9,
		1165
	],
	"./components/Customer/PaymentFailureMsg.jsx": [
		51165,
		9,
		1165
	],
	"./components/Customer/PaymentOption": [
		81927,
		9,
		8071,
		1927
	],
	"./components/Customer/PaymentOption.jsx": [
		81927,
		9,
		8071,
		1927
	],
	"./components/Customer/PaymentSuccessMsg": [
		68124,
		9,
		8124
	],
	"./components/Customer/PaymentSuccessMsg.jsx": [
		68124,
		9,
		8124
	],
	"./components/Customer/PaymentSummary": [
		66790,
		9,
		7739,
		6790
	],
	"./components/Customer/PaymentSummary.jsx": [
		66790,
		9,
		7739,
		6790
	],
	"./components/Customer/Profile/Screen/CustomerProfileMain": [
		4847,
		9,
		7195,
		681,
		4018,
		6536,
		5255,
		4847
	],
	"./components/Customer/Profile/Screen/CustomerProfileMain.jsx": [
		4847,
		9,
		7195,
		681,
		4018,
		6536,
		5255,
		4847
	],
	"./components/Customer/Profile/Screen/CustomerProfileSignIn": [
		89449,
		9,
		1830
	],
	"./components/Customer/Profile/Screen/CustomerProfileSignIn.jsx": [
		89449,
		9,
		1830
	],
	"./components/Customer/Profile/Screen/CustomerViewAllAddress": [
		45255,
		9,
		5255,
		7995
	],
	"./components/Customer/Profile/Screen/CustomerViewAllAddress.jsx": [
		45255,
		9,
		5255,
		7995
	],
	"./components/Customer/Profile/Section/AddOrEditAddressBox": [
		92817,
		9,
		5198
	],
	"./components/Customer/Profile/Section/AddOrEditAddressBox.jsx": [
		92817,
		9,
		5198
	],
	"./components/Customer/Profile/Section/AddressForm": [
		70918,
		9,
		918
	],
	"./components/Customer/Profile/Section/AddressForm.jsx": [
		70918,
		9,
		918
	],
	"./components/Customer/Profile/Section/AddressList": [
		27431,
		9,
		7431
	],
	"./components/Customer/Profile/Section/AddressList.jsx": [
		27431,
		9,
		7431
	],
	"./components/Customer/Profile/Section/CustomerDeleteAccount": [
		37630,
		9,
		7630
	],
	"./components/Customer/Profile/Section/CustomerDeleteAccount.jsx": [
		37630,
		9,
		7630
	],
	"./components/Customer/Profile/Section/CustomerEditContactNo": [
		35909,
		9,
		7195,
		681,
		4018,
		5909
	],
	"./components/Customer/Profile/Section/CustomerEditContactNo.jsx": [
		35909,
		9,
		7195,
		681,
		4018,
		5909
	],
	"./components/Customer/Profile/Section/CustomerEditEmail": [
		39940,
		9,
		9940
	],
	"./components/Customer/Profile/Section/CustomerEditEmail.jsx": [
		39940,
		9,
		9940
	],
	"./components/Customer/Profile/Section/CustomerEditUserName": [
		86870,
		9,
		6870
	],
	"./components/Customer/Profile/Section/CustomerEditUserName.jsx": [
		86870,
		9,
		6870
	],
	"./components/Customer/Profile/Section/CustomerProfileChangeDialogBox": [
		81288,
		9,
		1288
	],
	"./components/Customer/Profile/Section/CustomerProfileChangeDialogBox.jsx": [
		81288,
		9,
		1288
	],
	"./components/Customer/Profile/Section/DeleteAccountDialogBox": [
		34891,
		9,
		4891
	],
	"./components/Customer/Profile/Section/DeleteAccountDialogBox.jsx": [
		34891,
		9,
		4891
	],
	"./components/Customer/Profile/Section/DeletePrimaryAddress": [
		29801,
		9,
		9801
	],
	"./components/Customer/Profile/Section/DeletePrimaryAddress.jsx": [
		29801,
		9,
		9801
	],
	"./components/Customer/Profile/Section/EditDetailsDialogBox": [
		95479,
		9,
		5479
	],
	"./components/Customer/Profile/Section/EditDetailsDialogBox.jsx": [
		95479,
		9,
		5479
	],
	"./components/Customer/Profile/Section/EditPrimaryAddress": [
		64224,
		9,
		4224
	],
	"./components/Customer/Profile/Section/EditPrimaryAddress.jsx": [
		64224,
		9,
		4224
	],
	"./components/Customer/Profile/Section/LogoutDialogBox": [
		73637,
		9,
		3637
	],
	"./components/Customer/Profile/Section/LogoutDialogBox.jsx": [
		73637,
		9,
		3637
	],
	"./components/Customer/SignInOTP": [
		5499,
		9,
		7739,
		5499
	],
	"./components/Customer/SignInOTP.jsx": [
		5499,
		9,
		7739,
		5499
	],
	"./components/Customer/TrackOrders/Screen/CustomerAddOrderReview": [
		49529,
		9,
		7195,
		681,
		4018,
		6726,
		6536,
		4074,
		3938,
		5255,
		4847,
		9529
	],
	"./components/Customer/TrackOrders/Screen/CustomerAddOrderReview.jsx": [
		49529,
		9,
		7195,
		681,
		4018,
		6726,
		6536,
		4074,
		3938,
		5255,
		4847,
		9529
	],
	"./components/Customer/TrackOrders/Screen/CustomerAllPlacedOrders": [
		38599,
		9,
		7739,
		7195,
		681,
		4018,
		223,
		2155,
		1063,
		8599
	],
	"./components/Customer/TrackOrders/Screen/CustomerAllPlacedOrders.jsx": [
		38599,
		9,
		7739,
		7195,
		681,
		4018,
		223,
		2155,
		1063,
		8599
	],
	"./components/Customer/TrackOrders/Screen/CustomerPlacedOrderProgressDetail": [
		13563,
		9,
		7195,
		681,
		4018,
		1591,
		6536,
		9059,
		5255,
		4847,
		3563
	],
	"./components/Customer/TrackOrders/Screen/CustomerPlacedOrderProgressDetail.jsx": [
		13563,
		9,
		7195,
		681,
		4018,
		1591,
		6536,
		9059,
		5255,
		4847,
		3563
	],
	"./components/Customer/TrackOrders/Section/CancelOrderConfirmationDialog": [
		68872,
		9,
		8872
	],
	"./components/Customer/TrackOrders/Section/CancelOrderConfirmationDialog.jsx": [
		68872,
		9,
		8872
	],
	"./components/Customer/TrackOrders/Section/CancelOrderResponseDialog": [
		15010,
		9,
		5010
	],
	"./components/Customer/TrackOrders/Section/CancelOrderResponseDialog.jsx": [
		15010,
		9,
		5010
	],
	"./components/Customer/TrackOrders/Section/CustomerOrderDetail": [
		70970,
		9,
		970
	],
	"./components/Customer/TrackOrders/Section/CustomerOrderDetail.jsx": [
		70970,
		9,
		970
	],
	"./components/Customer/TrackOrders/Section/OrderStatusTimeline": [
		39471,
		9,
		9059,
		9471
	],
	"./components/Customer/TrackOrders/Section/OrderStatusTimeline.jsx": [
		39471,
		9,
		9059,
		9471
	],
	"./components/Customer/TrackOrders/Section/PlacedOrderCard": [
		5002,
		9,
		5002
	],
	"./components/Customer/TrackOrders/Section/PlacedOrderCard.jsx": [
		5002,
		9,
		5002
	],
	"./components/Customer/UploadPaymentProof": [
		14775,
		9,
		4775
	],
	"./components/Customer/UploadPaymentProof.jsx": [
		14775,
		9,
		4775
	],
	"./components/Customer/Utils/CustomerStyledObjects": [
		52037,
		9,
		2037
	],
	"./components/Customer/Utils/CustomerStyledObjects.js": [
		52037,
		9,
		2037
	],
	"./components/Customer/Utils/CustomerStyledTags": [
		44956,
		9,
		4956
	],
	"./components/Customer/Utils/CustomerStyledTags.js": [
		44956,
		9,
		4956
	],
	"./components/Customer/Utils/customScrollBar.css": [
		87414,
		9
	],
	"./components/Customer/Utils/customScrollBar2.css": [
		6982,
		9,
		6982
	],
	"./components/Customer/VendorAvaiDeliveryAreaAndTime": [
		2944,
		9,
		8071,
		2944
	],
	"./components/Customer/VendorAvaiDeliveryAreaAndTime.jsx": [
		2944,
		9,
		8071,
		2944
	],
	"./components/Customer/VendorAvailableDeliveryAreaAndFee": [
		19339,
		9,
		9339
	],
	"./components/Customer/VendorAvailableDeliveryAreaAndFee.jsx": [
		19339,
		9,
		9339
	],
	"./components/Customer/VendorClosedMessageBox": [
		99886,
		9,
		9886
	],
	"./components/Customer/VendorClosedMessageBox.jsx": [
		99886,
		9,
		9886
	],
	"./components/Customer/VendorInfo": [
		11954,
		9,
		7739,
		7195,
		681,
		8071,
		4018,
		1591,
		6726,
		3316,
		223,
		2155,
		6131,
		8776,
		4353,
		9334,
		1063,
		2360,
		8599,
		4485,
		5952,
		1954,
		2117
	],
	"./components/Customer/VendorInfo.jsx": [
		11954,
		9,
		7739,
		7195,
		681,
		8071,
		4018,
		1591,
		6726,
		3316,
		223,
		2155,
		6131,
		8776,
		4353,
		9334,
		1063,
		2360,
		8599,
		4485,
		5952,
		1954,
		2117
	],
	"./components/Customer/VendorSearch": [
		89194,
		9,
		9194
	],
	"./components/Customer/VendorSearch.jsx": [
		89194,
		9,
		9194
	],
	"./components/Customer/authentication/AddCustomerInfo": [
		86152,
		9,
		7195,
		681,
		4018,
		6152
	],
	"./components/Customer/authentication/AddCustomerInfo.jsx": [
		86152,
		9,
		7195,
		681,
		4018,
		6152
	],
	"./components/Customer/authentication/CustomerSigninSuccess": [
		46442,
		9,
		6442
	],
	"./components/Customer/authentication/CustomerSigninSuccess.jsx": [
		46442,
		9,
		6442
	],
	"./components/Customer/authentication/SigninCustomerViaEmail": [
		98251,
		9,
		7739,
		8251
	],
	"./components/Customer/authentication/SigninCustomerViaEmail.jsx": [
		98251,
		9,
		7739,
		8251
	],
	"./components/ErrorPages/ErrorPageTemplete": [
		94269,
		9,
		4269
	],
	"./components/ErrorPages/ErrorPageTemplete.jsx": [
		94269,
		9,
		4269
	],
	"./components/ErrorPages/MaintenanceScreen": [
		33633,
		9,
		3633
	],
	"./components/ErrorPages/MaintenanceScreen.jsx": [
		33633,
		9,
		3633
	],
	"./components/ErrorPages/NotAvailableNow": [
		54752,
		9,
		4752
	],
	"./components/ErrorPages/NotAvailableNow.jsx": [
		54752,
		9,
		4752
	],
	"./components/LandingPage/LandingMainScreen": [
		10424,
		9,
		424
	],
	"./components/LandingPage/LandingMainScreen.jsx": [
		10424,
		9,
		424
	],
	"./components/LandingPage/Screens/LandingMainScreen": [
		12122,
		9,
		2122
	],
	"./components/LandingPage/Screens/LandingMainScreen.jsx": [
		12122,
		9,
		2122
	],
	"./components/LandingPage/Screens/PrivacyPolicyScreen": [
		28506,
		9,
		8506
	],
	"./components/LandingPage/Screens/PrivacyPolicyScreen.jsx": [
		28506,
		9,
		8506
	],
	"./components/LandingPage/Screens/TermsAndConditions": [
		96804,
		9,
		6804
	],
	"./components/LandingPage/Screens/TermsAndConditions.jsx": [
		96804,
		9,
		6804
	],
	"./components/LandingPage/Sections/DetailsMessages": [
		30267,
		9,
		267
	],
	"./components/LandingPage/Sections/DetailsMessages.jsx": [
		30267,
		9,
		267
	],
	"./components/LandingPage/Sections/FAQ": [
		42289,
		9,
		2289
	],
	"./components/LandingPage/Sections/FAQ.jsx": [
		42289,
		9,
		2289
	],
	"./components/LandingPage/Sections/ManageYourOrder": [
		54741,
		9,
		4741,
		5642
	],
	"./components/LandingPage/Sections/ManageYourOrder.jsx": [
		54741,
		9,
		4741,
		5642
	],
	"./components/LandingPage/Sections/ScheduleFreeDemo": [
		51345,
		9,
		1345
	],
	"./components/LandingPage/Sections/ScheduleFreeDemo.jsx": [
		51345,
		9,
		1345
	],
	"./components/LandingPage/Sections/SimpleMembership": [
		78135,
		9,
		8135
	],
	"./components/LandingPage/Sections/SimpleMembership.jsx": [
		78135,
		9,
		8135
	],
	"./components/LandingPage/Sections/WhatIsFeasto": [
		97535,
		9,
		7535
	],
	"./components/LandingPage/Sections/WhatIsFeasto.jsx": [
		97535,
		9,
		7535
	],
	"./components/LandingPage/Utils/LandingStyledObjects": [
		13526,
		9,
		3526
	],
	"./components/LandingPage/Utils/LandingStyledObjects.js": [
		13526,
		9,
		3526
	],
	"./components/LandingPage/Utils/LandingStyledTags": [
		55642,
		9,
		5642
	],
	"./components/LandingPage/Utils/LandingStyledTags.js": [
		55642,
		9,
		5642
	],
	"./components/LandingPageV2/Screens/AboutUs": [
		25251,
		9,
		1591,
		9650,
		3254,
		5251
	],
	"./components/LandingPageV2/Screens/AboutUs.jsx": [
		25251,
		9,
		1591,
		9650,
		3254,
		5251
	],
	"./components/LandingPageV2/Screens/Careers": [
		15221,
		9,
		1591,
		9650,
		6939,
		5221
	],
	"./components/LandingPageV2/Screens/Careers.jsx": [
		15221,
		9,
		1591,
		9650,
		6939,
		5221
	],
	"./components/LandingPageV2/Screens/Grocery": [
		97749,
		9,
		9650,
		4288,
		7749
	],
	"./components/LandingPageV2/Screens/Grocery.jsx": [
		97749,
		9,
		9650,
		4288,
		7749
	],
	"./components/LandingPageV2/Screens/LandingPageMainScreen": [
		7367,
		9,
		1591,
		9650,
		9496,
		9935,
		5218,
		8959,
		6578,
		7367
	],
	"./components/LandingPageV2/Screens/LandingPageMainScreen.jsx": [
		7367,
		9,
		1591,
		9650,
		9496,
		9935,
		5218,
		8959,
		6578,
		7367
	],
	"./components/LandingPageV2/Screens/PrivacyPolicyScreen": [
		48314,
		9,
		1591,
		9650,
		7390,
		8314
	],
	"./components/LandingPageV2/Screens/PrivacyPolicyScreen.jsx": [
		48314,
		9,
		1591,
		9650,
		7390,
		8314
	],
	"./components/LandingPageV2/Screens/Restaurant": [
		67667,
		9,
		9650,
		4288,
		7667
	],
	"./components/LandingPageV2/Screens/Restaurant.jsx": [
		67667,
		9,
		9650,
		4288,
		7667
	],
	"./components/LandingPageV2/Screens/Retail": [
		6527,
		9,
		9650,
		4288,
		6527
	],
	"./components/LandingPageV2/Screens/Retail.jsx": [
		6527,
		9,
		9650,
		4288,
		6527
	],
	"./components/LandingPageV2/Screens/TermsAndConditions": [
		16004,
		9,
		1591,
		9650,
		7390,
		3623
	],
	"./components/LandingPageV2/Screens/TermsAndConditions.jsx": [
		16004,
		9,
		1591,
		9650,
		7390,
		3623
	],
	"./components/LandingPageV2/Section/AnimatedImages": [
		78785,
		9,
		9496,
		8785
	],
	"./components/LandingPageV2/Section/AnimatedImages.jsx": [
		78785,
		9,
		9496,
		8785
	],
	"./components/LandingPageV2/Section/CareersFAQ": [
		45715,
		9,
		5715
	],
	"./components/LandingPageV2/Section/CareersFAQ.jsx": [
		45715,
		9,
		5715
	],
	"./components/LandingPageV2/Section/CarreesVideoSection": [
		75257,
		9,
		5257
	],
	"./components/LandingPageV2/Section/CarreesVideoSection.jsx": [
		75257,
		9,
		5257
	],
	"./components/LandingPageV2/Section/CheckLinkedInAndPtotos": [
		32266,
		9,
		2266
	],
	"./components/LandingPageV2/Section/CheckLinkedInAndPtotos.jsx": [
		32266,
		9,
		2266
	],
	"./components/LandingPageV2/Section/CompaniesBrandLogos": [
		6578,
		9,
		9496,
		6578
	],
	"./components/LandingPageV2/Section/CompaniesBrandLogos.jsx": [
		6578,
		9,
		9496,
		6578
	],
	"./components/LandingPageV2/Section/DiscoverWhatFeasto": [
		79187,
		9,
		9935,
		9187
	],
	"./components/LandingPageV2/Section/DiscoverWhatFeasto.jsx": [
		79187,
		9,
		9935,
		9187
	],
	"./components/LandingPageV2/Section/FAQ": [
		31954,
		9,
		9573
	],
	"./components/LandingPageV2/Section/FAQ.jsx": [
		31954,
		9,
		9573
	],
	"./components/LandingPageV2/Section/Footer": [
		51433,
		9,
		9650,
		1433
	],
	"./components/LandingPageV2/Section/Footer.jsx": [
		51433,
		9,
		9650,
		1433
	],
	"./components/LandingPageV2/Section/OurStory": [
		67481,
		9,
		7481
	],
	"./components/LandingPageV2/Section/OurStory.jsx": [
		67481,
		9,
		7481
	],
	"./components/LandingPageV2/Section/OurTeam": [
		87467,
		9,
		7467
	],
	"./components/LandingPageV2/Section/OurTeam.jsx": [
		87467,
		9,
		7467
	],
	"./components/LandingPageV2/Section/OurValues": [
		91786,
		9,
		1786
	],
	"./components/LandingPageV2/Section/OurValues.jsx": [
		91786,
		9,
		1786
	],
	"./components/LandingPageV2/Section/Pricing": [
		9960,
		9,
		9960
	],
	"./components/LandingPageV2/Section/Pricing.jsx": [
		9960,
		9,
		9960
	],
	"./components/LandingPageV2/Section/ResponsiveAppBar": [
		81966,
		9,
		1966
	],
	"./components/LandingPageV2/Section/ResponsiveAppBar.jsx": [
		81966,
		9,
		1966
	],
	"./components/LandingPageV2/Section/ResponsiveComponent": [
		38757,
		9,
		8757
	],
	"./components/LandingPageV2/Section/ResponsiveComponent.jsx": [
		38757,
		9,
		8757
	],
	"./components/LandingPageV2/Section/RightsReserved": [
		18905,
		9,
		8905
	],
	"./components/LandingPageV2/Section/RightsReserved.jsx": [
		18905,
		9,
		8905
	],
	"./components/LandingPageV2/Section/StoreTempletes": [
		49292,
		9,
		9292
	],
	"./components/LandingPageV2/Section/StoreTempletes.jsx": [
		49292,
		9,
		9292
	],
	"./components/LandingPageV2/Section/TestimonialSection": [
		71098,
		9,
		1098
	],
	"./components/LandingPageV2/Section/TestimonialSection.jsx": [
		71098,
		9,
		1098
	],
	"./components/LandingPageV2/Section/TopHeading": [
		38959,
		9,
		8959,
		6502
	],
	"./components/LandingPageV2/Section/TopHeading.jsx": [
		38959,
		9,
		8959,
		6502
	],
	"./components/LandingPageV2/Section/WhoWeAre": [
		77142,
		9,
		7142
	],
	"./components/LandingPageV2/Section/WhoWeAre.jsx": [
		77142,
		9,
		7142
	],
	"./components/LandingPageV2/Section/WhyFeasto": [
		30660,
		9,
		660
	],
	"./components/LandingPageV2/Section/WhyFeasto.jsx": [
		30660,
		9,
		660
	],
	"./components/LandingPageV2/Utils/LandingPageStyledObject": [
		64712,
		9,
		4712
	],
	"./components/LandingPageV2/Utils/LandingPageStyledObject.js": [
		64712,
		9,
		4712
	],
	"./components/LandingPageV2/Utils/LandingPageStyledTags": [
		84150,
		7,
		4150
	],
	"./components/LandingPageV2/Utils/LandingPageStyledTags.js": [
		84150,
		7,
		4150
	],
	"./components/Utils/FieldFormatter": [
		61193,
		9,
		1193
	],
	"./components/Utils/FieldFormatter.js": [
		61193,
		9,
		1193
	],
	"./components/Utils/PrivateRoute": [
		14499,
		9,
		4499
	],
	"./components/Utils/PrivateRoute.js": [
		14499,
		9,
		4499
	],
	"./components/Vendor/Items/Retail/Screen/AddAvailabilityAndPriceScreenForRetail": [
		95496,
		9,
		5496
	],
	"./components/Vendor/Items/Retail/Screen/AddAvailabilityAndPriceScreenForRetail.jsx": [
		95496,
		9,
		5496
	],
	"./components/Vendor/Items/Retail/Screen/AddOptionsForRetailScreen": [
		3463,
		9,
		2561,
		3463
	],
	"./components/Vendor/Items/Retail/Screen/AddOptionsForRetailScreen.jsx": [
		3463,
		9,
		2561,
		3463
	],
	"./components/Vendor/Items/Retail/Screen/AddVariantsForRetailScreen": [
		6719,
		9,
		2561,
		6719
	],
	"./components/Vendor/Items/Retail/Screen/AddVariantsForRetailScreen.jsx": [
		6719,
		9,
		2561,
		6719
	],
	"./components/Vendor/Items/Retail/Screen/CreateRetailBasedItemScreen1": [
		76090,
		9,
		7739,
		8071,
		6090
	],
	"./components/Vendor/Items/Retail/Screen/CreateRetailBasedItemScreen1.jsx": [
		76090,
		9,
		7739,
		8071,
		6090
	],
	"./components/Vendor/Items/Retail/Screen/VendorPreviewProductDetailForRetailScreen": [
		50328,
		9,
		328
	],
	"./components/Vendor/Items/Retail/Screen/VendorPreviewProductDetailForRetailScreen.jsx": [
		50328,
		9,
		328
	],
	"./components/Vendor/Items/Retail/Screen/VendorViewRetailItemScreen": [
		18235,
		9,
		8235
	],
	"./components/Vendor/Items/Retail/Screen/VendorViewRetailItemScreen.jsx": [
		18235,
		9,
		8235
	],
	"./components/Vendor/Items/Retail/Section/PriceEnteringSectionForRetail": [
		56811,
		9,
		6811
	],
	"./components/Vendor/Items/Retail/Section/PriceEnteringSectionForRetail.jsx": [
		56811,
		9,
		6811
	],
	"./components/Vendor/Items/Screen/AddVariantsAndOptions": [
		89236,
		9,
		9236
	],
	"./components/Vendor/Items/Screen/AddVariantsAndOptions.jsx": [
		89236,
		9,
		9236
	],
	"./components/Vendor/Items/Screen/Grocery/CreateNewItemUnitBased": [
		28228,
		9,
		8228
	],
	"./components/Vendor/Items/Screen/Grocery/CreateNewItemUnitBased.jsx": [
		28228,
		9,
		8228
	],
	"./components/Vendor/Items/Screen/Grocery/UnitBasedItemReviewConfirm": [
		94476,
		9,
		4476
	],
	"./components/Vendor/Items/Screen/Grocery/UnitBasedItemReviewConfirm.jsx": [
		94476,
		9,
		4476
	],
	"./components/Vendor/Items/Screen/ItemCreationOption": [
		9647,
		9,
		8071,
		9647
	],
	"./components/Vendor/Items/Screen/ItemCreationOption.jsx": [
		9647,
		9,
		8071,
		9647
	],
	"./components/Vendor/Items/Screen/PreviewScreen": [
		66936,
		9,
		6936
	],
	"./components/Vendor/Items/Screen/PreviewScreen.jsx": [
		66936,
		9,
		6936
	],
	"./components/Vendor/Items/Screen/PriceAddingScreen": [
		30024,
		9,
		24
	],
	"./components/Vendor/Items/Screen/PriceAddingScreen.jsx": [
		30024,
		9,
		24
	],
	"./components/Vendor/Items/Screen/ReorderItemCategoryName": [
		96221,
		9,
		9496,
		2868,
		6221
	],
	"./components/Vendor/Items/Screen/ReorderItemCategoryName.jsx": [
		96221,
		9,
		9496,
		2868,
		6221
	],
	"./components/Vendor/Items/Screen/VendorAllItemsScreen": [
		52939,
		9,
		8071,
		3458,
		6680,
		2939
	],
	"./components/Vendor/Items/Screen/VendorAllItemsScreen.jsx": [
		52939,
		9,
		8071,
		3458,
		6680,
		2939
	],
	"./components/Vendor/Items/Screen/VendorCreateItemScreen1": [
		7752,
		9,
		7739,
		7752
	],
	"./components/Vendor/Items/Screen/VendorCreateItemScreen1.jsx": [
		7752,
		9,
		7739,
		7752
	],
	"./components/Vendor/Items/Screen/VendorItemSuccessMessageScreen": [
		34543,
		9,
		4543
	],
	"./components/Vendor/Items/Screen/VendorItemSuccessMessageScreen.jsx": [
		34543,
		9,
		4543
	],
	"./components/Vendor/Items/Screen/VendorShortcutToEditDeactivate": [
		98879,
		9,
		3458
	],
	"./components/Vendor/Items/Screen/VendorShortcutToEditDeactivate.jsx": [
		98879,
		9,
		3458
	],
	"./components/Vendor/Items/Screen/VendorViewItemScreen": [
		37302,
		9,
		7302
	],
	"./components/Vendor/Items/Screen/VendorViewItemScreen.jsx": [
		37302,
		9,
		7302
	],
	"./components/Vendor/Items/Section/PriceEnteringSection": [
		77439,
		9,
		7439
	],
	"./components/Vendor/Items/Section/PriceEnteringSection.jsx": [
		77439,
		9,
		7439
	],
	"./components/Vendor/Items/Section/VendorItemCard": [
		93944,
		9,
		3458
	],
	"./components/Vendor/Items/Section/VendorItemCard.jsx": [
		93944,
		9,
		3458
	],
	"./components/Vendor/Items/Section/VendorItemStatusChangeConfirmationDialog": [
		55175,
		9,
		5175
	],
	"./components/Vendor/Items/Section/VendorItemStatusChangeConfirmationDialog.jsx": [
		55175,
		9,
		5175
	],
	"./components/Vendor/Items/VendorItemFieldValidation": [
		23427,
		9,
		7739,
		3427
	],
	"./components/Vendor/Items/VendorItemFieldValidation.js": [
		23427,
		9,
		7739,
		3427
	],
	"./components/Vendor/Offers/Screen/VendorAllOffersScreen": [
		23339,
		9,
		2360,
		3339
	],
	"./components/Vendor/Offers/Screen/VendorAllOffersScreen.jsx": [
		23339,
		9,
		2360,
		3339
	],
	"./components/Vendor/Offers/Screen/VendorConfirmCreateOfferScreen": [
		27525,
		9,
		7525
	],
	"./components/Vendor/Offers/Screen/VendorConfirmCreateOfferScreen.jsx": [
		27525,
		9,
		7525
	],
	"./components/Vendor/Offers/Screen/VendorCreateOfferAddItems": [
		71342,
		9,
		1342
	],
	"./components/Vendor/Offers/Screen/VendorCreateOfferAddItems.jsx": [
		71342,
		9,
		1342
	],
	"./components/Vendor/Offers/Screen/VendorCreateOfferScreen1": [
		72192,
		9,
		7739,
		2192
	],
	"./components/Vendor/Offers/Screen/VendorCreateOfferScreen1.jsx": [
		72192,
		9,
		7739,
		2192
	],
	"./components/Vendor/Offers/Screen/VendorCreateOfferScreen2": [
		30811,
		9,
		7739,
		811
	],
	"./components/Vendor/Offers/Screen/VendorCreateOfferScreen2.jsx": [
		30811,
		9,
		7739,
		811
	],
	"./components/Vendor/Offers/Screen/VendorOfferSuccessMessageScreen": [
		43995,
		9,
		3995
	],
	"./components/Vendor/Offers/Screen/VendorOfferSuccessMessageScreen.jsx": [
		43995,
		9,
		3995
	],
	"./components/Vendor/Offers/Screen/VendorPreviewScreen": [
		76987,
		9,
		6987
	],
	"./components/Vendor/Offers/Screen/VendorPreviewScreen.jsx": [
		76987,
		9,
		6987
	],
	"./components/Vendor/Offers/Screen/VendorViewPreviewScreen": [
		35650,
		9,
		5650
	],
	"./components/Vendor/Offers/Screen/VendorViewPreviewScreen.jsx": [
		35650,
		9,
		5650
	],
	"./components/Vendor/Offers/Section/VendorOfferCard": [
		99592,
		9,
		9592
	],
	"./components/Vendor/Offers/Section/VendorOfferCard.jsx": [
		99592,
		9,
		9592
	],
	"./components/Vendor/Offers/Section/VendorOfferItemCard": [
		75445,
		9,
		5445
	],
	"./components/Vendor/Offers/Section/VendorOfferItemCard.jsx": [
		75445,
		9,
		5445
	],
	"./components/Vendor/Offers/Section/VendorOfferStatusChangeConfirmationDialog": [
		64279,
		9,
		4279
	],
	"./components/Vendor/Offers/Section/VendorOfferStatusChangeConfirmationDialog.jsx": [
		64279,
		9,
		4279
	],
	"./components/Vendor/Offers/VendorOfferFieldValidation": [
		9195,
		9,
		7739,
		9195
	],
	"./components/Vendor/Offers/VendorOfferFieldValidation.js": [
		9195,
		9,
		7739,
		9195
	],
	"./components/Vendor/Orders/Screen/ExportOrdersAsPdf": [
		89846,
		9,
		8071,
		2871,
		3229,
		9846
	],
	"./components/Vendor/Orders/Screen/ExportOrdersAsPdf.jsx": [
		89846,
		9,
		8071,
		2871,
		3229,
		9846
	],
	"./components/Vendor/Orders/Screen/ExportPdfFieldsSelection": [
		64284,
		9,
		4284
	],
	"./components/Vendor/Orders/Screen/ExportPdfFieldsSelection.jsx": [
		64284,
		9,
		4284
	],
	"./components/Vendor/Orders/Screen/PdfGenerationSuccessOrFailureScreen": [
		98707,
		9,
		8707
	],
	"./components/Vendor/Orders/Screen/PdfGenerationSuccessOrFailureScreen.jsx": [
		98707,
		9,
		8707
	],
	"./components/Vendor/Orders/Screen/PreparingPdfInProgressScreen": [
		47785,
		9,
		7762,
		557,
		7785
	],
	"./components/Vendor/Orders/Screen/PreparingPdfInProgressScreen.jsx": [
		47785,
		9,
		7762,
		557,
		7785
	],
	"./components/Vendor/Orders/Screen/VendorAllOrders": [
		44303,
		9,
		1591,
		1063,
		4144,
		4303
	],
	"./components/Vendor/Orders/Screen/VendorAllOrders.jsx": [
		44303,
		9,
		1591,
		1063,
		4144,
		4303
	],
	"./components/Vendor/Orders/Screen/VendorLastNOrdersByStatus": [
		26621,
		9,
		4144,
		6621
	],
	"./components/Vendor/Orders/Screen/VendorLastNOrdersByStatus.jsx": [
		26621,
		9,
		4144,
		6621
	],
	"./components/Vendor/Orders/Screen/VendorOrderCancelledOrCompletedSuccessScreen": [
		56856,
		9,
		6856
	],
	"./components/Vendor/Orders/Screen/VendorOrderCancelledOrCompletedSuccessScreen.jsx": [
		56856,
		9,
		6856
	],
	"./components/Vendor/Orders/Screen/VendorSummary": [
		23603,
		9,
		2871,
		3229,
		6726,
		4074,
		8257,
		2519,
		3603,
		4565
	],
	"./components/Vendor/Orders/Screen/VendorSummary.jsx": [
		23603,
		9,
		2871,
		3229,
		6726,
		4074,
		8257,
		2519,
		3603,
		4565
	],
	"./components/Vendor/Orders/Screen/VendorUpdateOrderStatus": [
		9738,
		9,
		1591,
		9738
	],
	"./components/Vendor/Orders/Screen/VendorUpdateOrderStatus.jsx": [
		9738,
		9,
		1591,
		9738
	],
	"./components/Vendor/Orders/Section/CalendarPopup": [
		19936,
		9,
		2871,
		3229,
		9936
	],
	"./components/Vendor/Orders/Section/CalendarPopup.jsx": [
		19936,
		9,
		2871,
		3229,
		9936
	],
	"./components/Vendor/Orders/Section/ExportPdf/DeliveryAreaSelection": [
		75406,
		9,
		5406
	],
	"./components/Vendor/Orders/Section/ExportPdf/DeliveryAreaSelection.jsx": [
		75406,
		9,
		5406
	],
	"./components/Vendor/Orders/Section/ExportPdf/DeliveryScheduleSelection": [
		44602,
		9,
		4602
	],
	"./components/Vendor/Orders/Section/ExportPdf/DeliveryScheduleSelection.jsx": [
		44602,
		9,
		4602
	],
	"./components/Vendor/Orders/Section/ExportPdf/DispatchModeSelection": [
		79830,
		9,
		7449
	],
	"./components/Vendor/Orders/Section/ExportPdf/DispatchModeSelection.jsx": [
		79830,
		9,
		7449
	],
	"./components/Vendor/Orders/Section/ExportPdf/OrderDetailsTablePdf": [
		92077,
		9,
		7762,
		557,
		2077
	],
	"./components/Vendor/Orders/Section/ExportPdf/OrderDetailsTablePdf.jsx": [
		92077,
		9,
		7762,
		557,
		2077
	],
	"./components/Vendor/Orders/Section/ExportPdf/OrderStatusSelection": [
		92457,
		9,
		2457
	],
	"./components/Vendor/Orders/Section/ExportPdf/OrderStatusSelection.jsx": [
		92457,
		9,
		2457
	],
	"./components/Vendor/Orders/Section/ExportPdf/SingleOrderDetailPdf": [
		92170,
		9,
		7762,
		557,
		2170
	],
	"./components/Vendor/Orders/Section/ExportPdf/SingleOrderDetailPdf.jsx": [
		92170,
		9,
		7762,
		557,
		2170
	],
	"./components/Vendor/Orders/Section/PaymentStatusDialogBox": [
		36793,
		9,
		6793
	],
	"./components/Vendor/Orders/Section/PaymentStatusDialogBox.jsx": [
		36793,
		9,
		6793
	],
	"./components/Vendor/Orders/Section/ReadFullDescriptionOfOrderDialog": [
		54534,
		9,
		4534
	],
	"./components/Vendor/Orders/Section/ReadFullDescriptionOfOrderDialog.jsx": [
		54534,
		9,
		4534
	],
	"./components/Vendor/Orders/Section/TotalOrdersCountByStatusContainer": [
		89344,
		9,
		9344
	],
	"./components/Vendor/Orders/Section/TotalOrdersCountByStatusContainer.jsx": [
		89344,
		9,
		9344
	],
	"./components/Vendor/Orders/Section/VendorOrderCard": [
		14144,
		9,
		4144
	],
	"./components/Vendor/Orders/Section/VendorOrderCard.jsx": [
		14144,
		9,
		4144
	],
	"./components/Vendor/Orders/Section/VendorOrderStatusChangeConfirmationDialog": [
		34255,
		9,
		4255
	],
	"./components/Vendor/Orders/Section/VendorOrderStatusChangeConfirmationDialog.jsx": [
		34255,
		9,
		4255
	],
	"./components/Vendor/Orders/Section/VendorRevenueSummaryCard": [
		32838,
		9,
		2838
	],
	"./components/Vendor/Orders/Section/VendorRevenueSummaryCard.jsx": [
		32838,
		9,
		2838
	],
	"./components/Vendor/Orders/Section/WeekPicker/WeekPicker": [
		96983,
		9,
		6726,
		4074,
		8257,
		6983
	],
	"./components/Vendor/Orders/Section/WeekPicker/WeekPicker.css": [
		99830,
		9,
		3801
	],
	"./components/Vendor/Orders/Section/WeekPicker/WeekPicker.jsx": [
		96983,
		9,
		6726,
		4074,
		8257,
		6983
	],
	"./components/Vendor/POS/Screen/POSCartScreen": [
		37850,
		9,
		8776,
		7850
	],
	"./components/Vendor/POS/Screen/POSCartScreen.jsx": [
		37850,
		9,
		8776,
		7850
	],
	"./components/Vendor/POS/Screen/POSCheckoutScreen1": [
		33999,
		9,
		8776,
		3999
	],
	"./components/Vendor/POS/Screen/POSCheckoutScreen1.jsx": [
		33999,
		9,
		8776,
		3999
	],
	"./components/Vendor/POS/Screen/POSCheckoutScreen2": [
		22559,
		9,
		7195,
		4018,
		6346,
		8776,
		2559
	],
	"./components/Vendor/POS/Screen/POSCheckoutScreen2.jsx": [
		22559,
		9,
		7195,
		4018,
		6346,
		8776,
		2559
	],
	"./components/Vendor/POS/Screen/POSHomeScreen": [
		30029,
		9,
		8071,
		6726,
		6680,
		5001,
		29
	],
	"./components/Vendor/POS/Screen/POSHomeScreen.jsx": [
		30029,
		9,
		8071,
		6726,
		6680,
		5001,
		29
	],
	"./components/Vendor/POS/Screen/POSInvoiceGeneratedSuccessScreen": [
		75859,
		9,
		5859
	],
	"./components/Vendor/POS/Screen/POSInvoiceGeneratedSuccessScreen.jsx": [
		75859,
		9,
		5859
	],
	"./components/Vendor/POS/Section/ItemQuantitySelectionPopup": [
		15001,
		9,
		8071,
		6726,
		5001,
		2505
	],
	"./components/Vendor/POS/Section/ItemQuantitySelectionPopup.jsx": [
		15001,
		9,
		8071,
		6726,
		5001,
		2505
	],
	"./components/Vendor/Profile/Screen/Appearance": [
		73723,
		9,
		2561,
		3723
	],
	"./components/Vendor/Profile/Screen/Appearance.jsx": [
		73723,
		9,
		2561,
		3723
	],
	"./components/Vendor/Profile/Screen/ConnectingDomain": [
		19355,
		9,
		9355
	],
	"./components/Vendor/Profile/Screen/ConnectingDomain.jsx": [
		19355,
		9,
		9355
	],
	"./components/Vendor/Profile/Screen/CurrencyPrefScreen": [
		97171,
		9,
		8071,
		7171
	],
	"./components/Vendor/Profile/Screen/CurrencyPrefScreen.jsx": [
		97171,
		9,
		8071,
		7171
	],
	"./components/Vendor/Profile/Screen/DomainDetails": [
		86387,
		9,
		7739,
		6387
	],
	"./components/Vendor/Profile/Screen/DomainDetails.jsx": [
		86387,
		9,
		7739,
		6387
	],
	"./components/Vendor/Profile/Screen/Domains": [
		75839,
		9,
		5839
	],
	"./components/Vendor/Profile/Screen/Domains.jsx": [
		75839,
		9,
		5839
	],
	"./components/Vendor/Profile/Screen/MarketingMainScreen": [
		92605,
		9,
		4353,
		2605
	],
	"./components/Vendor/Profile/Screen/MarketingMainScreen.jsx": [
		92605,
		9,
		4353,
		2605
	],
	"./components/Vendor/Profile/Screen/PreferencesScreen": [
		54975,
		9,
		4975
	],
	"./components/Vendor/Profile/Screen/PreferencesScreen.jsx": [
		54975,
		9,
		4975
	],
	"./components/Vendor/Profile/Screen/Promotion": [
		10450,
		9,
		450
	],
	"./components/Vendor/Profile/Screen/Promotion.jsx": [
		10450,
		9,
		450
	],
	"./components/Vendor/Profile/Screen/QRCodeGenerator": [
		31784,
		9,
		7762,
		5239,
		2817,
		1784
	],
	"./components/Vendor/Profile/Screen/QRCodeGenerator.jsx": [
		31784,
		9,
		7762,
		5239,
		2817,
		1784
	],
	"./components/Vendor/Profile/Screen/StoreCustomization": [
		8731,
		9,
		8731
	],
	"./components/Vendor/Profile/Screen/StoreCustomization.jsx": [
		8731,
		9,
		8731
	],
	"./components/Vendor/Profile/Screen/Storefront": [
		94133,
		9,
		8713,
		4353,
		9334,
		4133
	],
	"./components/Vendor/Profile/Screen/Storefront.jsx": [
		94133,
		9,
		8713,
		4353,
		9334,
		4133
	],
	"./components/Vendor/Profile/Screen/TimeFormatSelectionScreen": [
		35501,
		9,
		8071,
		5501
	],
	"./components/Vendor/Profile/Screen/TimeFormatSelectionScreen.jsx": [
		35501,
		9,
		8071,
		5501
	],
	"./components/Vendor/Profile/Screen/VendorEditProfileDetailsSuccessScreen": [
		89527,
		9,
		9527
	],
	"./components/Vendor/Profile/Screen/VendorEditProfileDetailsSuccessScreen.jsx": [
		89527,
		9,
		9527
	],
	"./components/Vendor/Profile/Screen/VendorProfileEditDetails": [
		48816,
		9,
		8816
	],
	"./components/Vendor/Profile/Screen/VendorProfileEditDetails.jsx": [
		48816,
		9,
		8816
	],
	"./components/Vendor/Profile/Screen/VendorProfileMainScreen": [
		53839,
		9,
		3839
	],
	"./components/Vendor/Profile/Screen/VendorProfileMainScreen.jsx": [
		53839,
		9,
		3839
	],
	"./components/Vendor/Profile/Screen/VendorProfileManageAccount": [
		53460,
		9,
		3460
	],
	"./components/Vendor/Profile/Screen/VendorProfileManageAccount.jsx": [
		53460,
		9,
		3460
	],
	"./components/Vendor/Profile/Section/DomainConnectingLoader": [
		22683,
		9,
		2683
	],
	"./components/Vendor/Profile/Section/DomainConnectingLoader.jsx": [
		22683,
		9,
		2683
	],
	"./components/Vendor/Profile/Section/DomainNamePopup": [
		74447,
		9,
		4447
	],
	"./components/Vendor/Profile/Section/DomainNamePopup.jsx": [
		74447,
		9,
		4447
	],
	"./components/Vendor/Profile/Section/LinkCard": [
		49212,
		9,
		8713,
		4353,
		9334,
		9212
	],
	"./components/Vendor/Profile/Section/LinkCard.jsx": [
		49212,
		9,
		8713,
		4353,
		9334,
		9212
	],
	"./components/Vendor/Profile/Section/Loader.css": [
		31800,
		9,
		1800
	],
	"./components/Vendor/Profile/Section/VendorProfileChangeDialogBox": [
		53324,
		9
	],
	"./components/Vendor/Profile/Section/VendorProfileChangeDialogBox.jsx": [
		53324,
		9
	],
	"./components/Vendor/Services/Screen/DeliveryConfigurations": [
		18437,
		9
	],
	"./components/Vendor/Services/Screen/DeliveryConfigurations.jsx": [
		18437,
		9
	],
	"./components/Vendor/Services/Screen/DeliveryForm": [
		52929,
		9
	],
	"./components/Vendor/Services/Screen/DeliveryForm.jsx": [
		52929,
		9
	],
	"./components/Vendor/Services/Screen/DeliveryRestrictionTime": [
		48955,
		9
	],
	"./components/Vendor/Services/Screen/DeliveryRestrictionTime.jsx": [
		48955,
		9
	],
	"./components/Vendor/Services/Screen/DigitalPayments/DeleteStripeConfirmation": [
		99561,
		9,
		9561
	],
	"./components/Vendor/Services/Screen/DigitalPayments/DeleteStripeConfirmation.jsx": [
		99561,
		9,
		9561
	],
	"./components/Vendor/Services/Screen/DigitalPayments/ReactivateStripeConfirmation": [
		67236,
		9,
		7236
	],
	"./components/Vendor/Services/Screen/DigitalPayments/ReactivateStripeConfirmation.jsx": [
		67236,
		9,
		7236
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorPayHereConfiguration": [
		53148,
		9,
		3148
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorPayHereConfiguration.jsx": [
		53148,
		9,
		3148
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorStripeConfiguration": [
		31219,
		9,
		1219
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorStripeConfiguration.jsx": [
		31219,
		9,
		1219
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorStripeConnectionFailedScreen": [
		12394,
		9,
		2394
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorStripeConnectionFailedScreen.jsx": [
		12394,
		9,
		2394
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorStripeConnectionSuccessScreen": [
		11104,
		9,
		1104
	],
	"./components/Vendor/Services/Screen/DigitalPayments/VendorStripeConnectionSuccessScreen.jsx": [
		11104,
		9,
		1104
	],
	"./components/Vendor/Services/Screen/ServiceMainScreen": [
		22032,
		9,
		2032
	],
	"./components/Vendor/Services/Screen/ServiceMainScreen.jsx": [
		22032,
		9,
		2032
	],
	"./components/Vendor/Services/Screen/ServiceOpeningHours": [
		66534,
		9
	],
	"./components/Vendor/Services/Screen/ServiceOpeningHours.jsx": [
		66534,
		9
	],
	"./components/Vendor/Services/Screen/Switch/switch.css": [
		41110,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageBankDetails": [
		96263,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageBankDetails.jsx": [
		96263,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageDeiveryAreaFeeScreen": [
		45912,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageDeiveryAreaFeeScreen.jsx": [
		45912,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageDigitalPaymentMethods": [
		95383,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageDigitalPaymentMethods.jsx": [
		95383,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageDispatchMode": [
		83292,
		9
	],
	"./components/Vendor/Services/Screen/VendorManageDispatchMode.jsx": [
		83292,
		9
	],
	"./components/Vendor/Services/Screen/VendorManagePaymentMethodScreen": [
		83242,
		9
	],
	"./components/Vendor/Services/Screen/VendorManagePaymentMethodScreen.jsx": [
		83242,
		9
	],
	"./components/Vendor/Services/Screen/VendorNotifyDelayDelivery": [
		16578,
		9,
		1340
	],
	"./components/Vendor/Services/Screen/VendorNotifyDelayDelivery.jsx": [
		16578,
		9,
		1340
	],
	"./components/Vendor/Services/Screen/VendorPOSAdditionalCharges": [
		35006,
		9
	],
	"./components/Vendor/Services/Screen/VendorPOSAdditionalCharges.jsx": [
		35006,
		9
	],
	"./components/Vendor/Services/Screen/VendorUpdateServiceSuccessMessage": [
		72018,
		9,
		2018
	],
	"./components/Vendor/Services/Screen/VendorUpdateServiceSuccessMessage.jsx": [
		72018,
		9,
		2018
	],
	"./components/Vendor/Services/Screen/VendorUpdatingTime": [
		39287,
		9,
		9287
	],
	"./components/Vendor/Services/Screen/VendorUpdatingTime.jsx": [
		39287,
		9,
		9287
	],
	"./components/Vendor/Services/Section/DeliveryAreaIsNotUniqueMsg": [
		41341,
		9
	],
	"./components/Vendor/Services/Section/DeliveryAreaIsNotUniqueMsg.jsx": [
		41341,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/DeleteConfirmation": [
		83599,
		9,
		3599
	],
	"./components/Vendor/Services/Section/DialogBoxes/DeleteConfirmation.jsx": [
		83599,
		9,
		3599
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageDeliveryModeConfirmation": [
		41174,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageDeliveryModeConfirmation.jsx": [
		41174,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageDineinModeConfirmation": [
		46597,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageDineinModeConfirmation.jsx": [
		46597,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageShopAvailabiliyConfirmation": [
		120,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageShopAvailabiliyConfirmation.jsx": [
		120,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageTakeAwayModeConfirmation": [
		10245,
		9
	],
	"./components/Vendor/Services/Section/DialogBoxes/ManageTakeAwayModeConfirmation.jsx": [
		10245,
		9
	],
	"./components/Vendor/Services/Section/PaymentMethodSelection": [
		79938,
		9
	],
	"./components/Vendor/Services/Section/PaymentMethodSelection.jsx": [
		79938,
		9
	],
	"./components/Vendor/Services/Section/TimeSelectionForm": [
		52574,
		9,
		2574
	],
	"./components/Vendor/Services/Section/TimeSelectionForm.jsx": [
		52574,
		9,
		2574
	],
	"./components/Vendor/Services/Section/UpdateTimeComponent": [
		55794,
		9,
		5794
	],
	"./components/Vendor/Services/Section/UpdateTimeComponent.jsx": [
		55794,
		9,
		5794
	],
	"./components/Vendor/Subscription/Screen/BillHistory/VendorViewPaymentHistory": [
		25832,
		9,
		5832
	],
	"./components/Vendor/Subscription/Screen/BillHistory/VendorViewPaymentHistory.jsx": [
		25832,
		9,
		5832
	],
	"./components/Vendor/Subscription/Screen/BillHistory/VendorViewReceiptScreen": [
		4396,
		9,
		7739,
		9667,
		4396
	],
	"./components/Vendor/Subscription/Screen/BillHistory/VendorViewReceiptScreen.jsx": [
		4396,
		9,
		7739,
		9667,
		4396
	],
	"./components/Vendor/Subscription/Screen/FreeToPro/VendorSubscriptionPlanDetails": [
		69830,
		9,
		7739,
		9830
	],
	"./components/Vendor/Subscription/Screen/FreeToPro/VendorSubscriptionPlanDetails.jsx": [
		69830,
		9,
		7739,
		9830
	],
	"./components/Vendor/Subscription/Screen/FreeToPro/VendorUpgradeSubscriptionScreen": [
		62325,
		9,
		2325
	],
	"./components/Vendor/Subscription/Screen/FreeToPro/VendorUpgradeSubscriptionScreen.jsx": [
		62325,
		9,
		2325
	],
	"./components/Vendor/Subscription/Screen/ManagePayments/VendorManagePaymentHomeScreen": [
		6119,
		9,
		6119
	],
	"./components/Vendor/Subscription/Screen/ManagePayments/VendorManagePaymentHomeScreen.jsx": [
		6119,
		9,
		6119
	],
	"./components/Vendor/Subscription/Screen/ManagePayments/VendorViewCardDetailsScreen": [
		92541,
		9,
		2541
	],
	"./components/Vendor/Subscription/Screen/ManagePayments/VendorViewCardDetailsScreen.jsx": [
		92541,
		9,
		2541
	],
	"./components/Vendor/Subscription/Screen/ManagePlan/VendorCancelSubscriptionScreen": [
		15963,
		9,
		5963
	],
	"./components/Vendor/Subscription/Screen/ManagePlan/VendorCancelSubscriptionScreen.jsx": [
		15963,
		9,
		5963
	],
	"./components/Vendor/Subscription/Screen/ManagePlan/VendorChangeSubscriptionPlanScreen": [
		96164,
		9,
		8071,
		6164
	],
	"./components/Vendor/Subscription/Screen/ManagePlan/VendorChangeSubscriptionPlanScreen.jsx": [
		96164,
		9,
		8071,
		6164
	],
	"./components/Vendor/Subscription/Screen/ManagePlan/VendorViewAvailablePlansScreen": [
		38498,
		9,
		8498
	],
	"./components/Vendor/Subscription/Screen/ManagePlan/VendorViewAvailablePlansScreen.jsx": [
		38498,
		9,
		8498
	],
	"./components/Vendor/Subscription/Screen/PaymentIssueFix/VendorChangePaymentCard": [
		35660,
		9,
		8071,
		5660
	],
	"./components/Vendor/Subscription/Screen/PaymentIssueFix/VendorChangePaymentCard.jsx": [
		35660,
		9,
		8071,
		5660
	],
	"./components/Vendor/Subscription/Screen/VendorManageSubscriptionScreen": [
		32691,
		9,
		2691
	],
	"./components/Vendor/Subscription/Screen/VendorManageSubscriptionScreen.jsx": [
		32691,
		9,
		2691
	],
	"./components/Vendor/Subscription/Section/BillHistory/VendorPaymentReceiptSentInEmailSuccessDialog": [
		92516,
		9,
		2516
	],
	"./components/Vendor/Subscription/Section/BillHistory/VendorPaymentReceiptSentInEmailSuccessDialog.jsx": [
		92516,
		9,
		2516
	],
	"./components/Vendor/Subscription/Section/FreeToPro/BenefitsOfProItem": [
		25794,
		9,
		3413
	],
	"./components/Vendor/Subscription/Section/FreeToPro/BenefitsOfProItem.jsx": [
		25794,
		9,
		3413
	],
	"./components/Vendor/Subscription/Section/ManagePayments/VendorPaymentMethodRemoveConfirmationDialog": [
		97471,
		9,
		7471
	],
	"./components/Vendor/Subscription/Section/ManagePayments/VendorPaymentMethodRemoveConfirmationDialog.jsx": [
		97471,
		9,
		7471
	],
	"./components/Vendor/Subscription/Section/ManagePlan/VendorCancelSubscriptionConfirmationDialog": [
		49367,
		9,
		9367
	],
	"./components/Vendor/Subscription/Section/ManagePlan/VendorCancelSubscriptionConfirmationDialog.jsx": [
		49367,
		9,
		9367
	],
	"./components/Vendor/Subscription/Section/ManagePlan/VendorRenewPlanConfirmationDialog": [
		51956,
		9,
		1956
	],
	"./components/Vendor/Subscription/Section/ManagePlan/VendorRenewPlanConfirmationDialog.jsx": [
		51956,
		9,
		1956
	],
	"./components/Vendor/Subscription/Section/ManagePlan/VendorSubscriptionCancelledSuccessDialog": [
		9220,
		9,
		9220
	],
	"./components/Vendor/Subscription/Section/ManagePlan/VendorSubscriptionCancelledSuccessDialog.jsx": [
		9220,
		9,
		9220
	],
	"./components/Vendor/Utils/VendorStyledObjects": [
		94005,
		9
	],
	"./components/Vendor/Utils/VendorStyledObjects.js": [
		94005,
		9
	],
	"./components/Vendor/Utils/VendorStyledTags": [
		41324,
		9
	],
	"./components/Vendor/Utils/VendorStyledTags.js": [
		41324,
		9
	],
	"./components/Vendor/authentication/AddOwnerInfo": [
		58461,
		9,
		7739,
		7195,
		681,
		4018,
		8461
	],
	"./components/Vendor/authentication/AddOwnerInfo.jsx": [
		58461,
		9,
		7739,
		7195,
		681,
		4018,
		8461
	],
	"./components/Vendor/authentication/AddVendorAddress": [
		96782,
		9,
		7739,
		6782
	],
	"./components/Vendor/authentication/AddVendorAddress.jsx": [
		96782,
		9,
		7739,
		6782
	],
	"./components/Vendor/authentication/AddVendorInfo": [
		52164,
		9,
		7739,
		681,
		2164
	],
	"./components/Vendor/authentication/AddVendorInfo.jsx": [
		52164,
		9,
		7739,
		681,
		2164
	],
	"./components/Vendor/authentication/AddVendorLogoAndURL": [
		29435,
		9,
		7739,
		8071,
		9435
	],
	"./components/Vendor/authentication/AddVendorLogoAndURL.jsx": [
		29435,
		9,
		7739,
		8071,
		9435
	],
	"./components/Vendor/authentication/Section/ContactUsBox": [
		76532,
		9,
		6532
	],
	"./components/Vendor/authentication/Section/ContactUsBox.jsx": [
		76532,
		9,
		6532
	],
	"./components/Vendor/authentication/SelectStoreType": [
		61692,
		9,
		1692
	],
	"./components/Vendor/authentication/SelectStoreType.jsx": [
		61692,
		9,
		1692
	],
	"./components/Vendor/authentication/SigninVendorViaContactNumber": [
		3368,
		9,
		7195,
		681,
		4018,
		223,
		3368
	],
	"./components/Vendor/authentication/SigninVendorViaContactNumber.jsx": [
		3368,
		9,
		7195,
		681,
		4018,
		223,
		3368
	],
	"./components/Vendor/authentication/SigninVendorViaEmail": [
		57479,
		9,
		7739,
		7479
	],
	"./components/Vendor/authentication/SigninVendorViaEmail.jsx": [
		57479,
		9,
		7739,
		7479
	],
	"./components/Vendor/authentication/SignupVendorViaEmail": [
		70873,
		9,
		7739,
		873
	],
	"./components/Vendor/authentication/SignupVendorViaEmail.jsx": [
		70873,
		9,
		7739,
		873
	],
	"./components/Vendor/authentication/SubscriptionConfirmation": [
		20520,
		9,
		8139
	],
	"./components/Vendor/authentication/SubscriptionConfirmation.jsx": [
		20520,
		9,
		8139
	],
	"./components/Vendor/authentication/VendorPlanDetails": [
		3412,
		9,
		3412
	],
	"./components/Vendor/authentication/VendorPlanDetails.jsx": [
		3412,
		9,
		3412
	],
	"./components/Vendor/authentication/VendorSigninSuccess": [
		86110,
		9,
		6110
	],
	"./components/Vendor/authentication/VendorSigninSuccess.jsx": [
		86110,
		9,
		6110
	],
	"./components/Vendor/authentication/VendorStatusPendingScreen": [
		66362,
		9,
		6362
	],
	"./components/Vendor/authentication/VendorStatusPendingScreen.jsx": [
		66362,
		9,
		6362
	],
	"./components/Vendor/authentication/VendorStatusScreenTemplete": [
		51045,
		9,
		1045
	],
	"./components/Vendor/authentication/VendorStatusScreenTemplete.jsx": [
		51045,
		9,
		1045
	],
	"./components/Vendor/authentication/VendorSubscriptionPlanSelection": [
		96313,
		9,
		6313
	],
	"./components/Vendor/authentication/VendorSubscriptionPlanSelection.jsx": [
		96313,
		9,
		6313
	],
	"./components/Vendor/authentication/VendorSubscriptionPlanSelector": [
		87300,
		9,
		3546,
		7300
	],
	"./components/Vendor/authentication/VendorSubscriptionPlanSelector.jsx": [
		87300,
		9,
		3546,
		7300
	],
	"./components/Vendor/style/ImgLoader": [
		63334,
		9,
		3334
	],
	"./components/Vendor/style/ImgLoader.jsx": [
		63334,
		9,
		3334
	],
	"./contexts/CartContext": [
		92224,
		9,
		2224
	],
	"./contexts/CartContext.js": [
		92224,
		9,
		2224
	],
	"./contexts/UserContext": [
		44107,
		9
	],
	"./contexts/UserContext.js": [
		44107,
		9
	],
	"./contexts/VendorContext": [
		66896,
		9
	],
	"./contexts/VendorContext.js": [
		66896,
		9
	],
	"./contexts/vendorRoutes": [
		8133,
		9
	],
	"./contexts/vendorRoutes.js": [
		8133,
		9
	],
	"./features/items": [
		99062,
		9
	],
	"./features/items.js": [
		99062,
		9
	],
	"./features/pos": [
		22216,
		9
	],
	"./features/pos.js": [
		22216,
		9
	],
	"./index": [
		64739,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.js": [
		64739,
		9
	],
	"./layouts/BottomNavbar": [
		30169,
		9,
		169
	],
	"./layouts/BottomNavbar.jsx": [
		30169,
		9,
		169
	],
	"./layouts/CustomDeliveryOptionButton": [
		82376,
		9,
		2376
	],
	"./layouts/CustomDeliveryOptionButton.jsx": [
		82376,
		9,
		2376
	],
	"./layouts/EmptyPageForMyCart": [
		28776,
		9,
		8776
	],
	"./layouts/EmptyPageForMyCart.jsx": [
		28776,
		9,
		8776
	],
	"./layouts/EmptyPageTemplete": [
		69116,
		9
	],
	"./layouts/EmptyPageTemplete.jsx": [
		69116,
		9
	],
	"./layouts/LimitReachedDialogBox": [
		44824,
		9,
		4824
	],
	"./layouts/LimitReachedDialogBox.jsx": [
		44824,
		9,
		4824
	],
	"./layouts/Loader": [
		90279,
		9
	],
	"./layouts/Loader.jsx": [
		90279,
		9
	],
	"./layouts/LoaderContext": [
		76430,
		9
	],
	"./layouts/LoaderContext.js": [
		76430,
		9
	],
	"./layouts/OrderInfo": [
		36760,
		9,
		6760
	],
	"./layouts/OrderInfo.jsx": [
		36760,
		9,
		6760
	],
	"./layouts/ProfileBasedLoader": [
		85975,
		9
	],
	"./layouts/ProfileBasedLoader.jsx": [
		85975,
		9
	],
	"./layouts/SideNavBarWebView": [
		32746,
		9
	],
	"./layouts/SideNavBarWebView.jsx": [
		32746,
		9
	],
	"./layouts/TopNavBarWebView": [
		35682,
		9
	],
	"./layouts/TopNavBarWebView.jsx": [
		35682,
		9
	],
	"./layouts/VendorBottomNavbar": [
		16763,
		9,
		6763
	],
	"./layouts/VendorBottomNavbar.jsx": [
		16763,
		9,
		6763
	],
	"./reportWebVitals": [
		89031,
		9
	],
	"./reportWebVitals.js": [
		89031,
		9
	],
	"./services/api": [
		79621,
		9
	],
	"./services/api.js": [
		79621,
		9
	],
	"./services/reduxStore": [
		61017,
		9
	],
	"./services/reduxStore.js": [
		61017,
		9
	],
	"./services/whatsapp": [
		34773,
		9,
		4773
	],
	"./services/whatsapp.jsx": [
		34773,
		9,
		4773
	],
	"./setupTests": [
		89472,
		9,
		2012,
		1405,
		9472
	],
	"./setupTests.js": [
		89472,
		9,
		2012,
		1405,
		9472
	],
	"./themeConfig": [
		59535,
		9
	],
	"./themeConfig.js": [
		59535,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28969;
module.exports = webpackAsyncContext;